<!-- v1 -->

<form [formGroup]="setupForm">
  <div class="setup-intro">
    <p>
      Use this tile to present content in icon-led columns. Configure each column’s text and icon,
      then set the shared background styling for the whole tile.
    </p>
  </div>

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Icon Columns</h2>
    </div>
    <div class="editor-section__content editor-section__content--spacious">
      <p class="section-intro">
        Each column combines a heading, supporting text, and an icon with its own position.
      </p>
      <div
        *ngFor="let iconColumn of iconColumns.controls; let i = index"
        [formGroup]="iconColumn"
        class="icon-columns-container"
      >
        <div class="icon-column-form">
          <button
            type="button"
            mat-icon-button
            class="icon-column-form__delete"
            aria-label="Remove icon column"
            (click)="removeIconColumn(i)"
          >
            <mat-icon>delete_forever</mat-icon>
          </button>

          <div class="icon-column-form__header">
            <h3>Column {{ i + 1 }}</h3>
          </div>

          <div class="icon-column-copy-group">
            <div class="icon-column-copy-group__controls">
              <mat-form-field appearance="outline" class="font-size-field">
                <mat-label>Heading Size</mat-label>
                <mat-select formControlName="headingFontSize">
                  <mat-option *ngFor="let sizeOption of fontSizesOptions" [value]="sizeOption">
                    {{ sizeOption }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <lib-color-picker-square
                [formGroup]="iconColumn"
                controlName="headingFontColor"
                [inputId]="'icon-column-heading-color-' + i"
                ariaLabel="Heading colour"
              ></lib-color-picker-square>
            </div>

            <mat-form-field appearance="fill" class="icon-column-copy-group__field">
              <mat-label>Heading</mat-label>
              <input matInput formControlName="heading" />
              <mat-hint>Sets the column heading.</mat-hint>
            </mat-form-field>
          </div>

          <div class="icon-column-copy-group">
            <div class="icon-column-copy-group__controls">
              <mat-form-field appearance="outline" class="font-size-field">
                <mat-label>Text Size</mat-label>
                <mat-select formControlName="textFontSize">
                  <mat-option *ngFor="let sizeOption of fontSizesOptions" [value]="sizeOption">
                    {{ sizeOption }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <lib-color-picker-square
                [formGroup]="iconColumn"
                controlName="textFontColor"
                [inputId]="'icon-column-text-color-' + i"
                ariaLabel="Text colour"
              ></lib-color-picker-square>
            </div>

            <mat-form-field appearance="fill" class="icon-column-copy-group__field">
              <mat-label>Text</mat-label>
              <textarea matInput formControlName="text" rows="4"></textarea>
              <mat-hint>Defines the supporting body text for the column.</mat-hint>
            </mat-form-field>
          </div>

          <hr class="icon-column-form__divider" />

          <div class="icon-column-icon-row">
            <mat-form-field appearance="fill" class="icon-column-icon-row__field">
              <mat-label>Icon</mat-label>
              <input matInput formControlName="icon" />
              <mat-hint>Sets the icon shown for the column.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="icon-column-icon-row__position">
              <mat-label>Icon Position</mat-label>
              <mat-select formControlName="iconPosition">
                <mat-option
                  *ngFor="let position of horizontalPositionOptions"
                  [value]="position.key"
                >
                  {{ position.name }}
                </mat-option>
              </mat-select>
              <mat-hint>Controls whether the icon appears before or after the text.</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <button class="add-btn" mat-raised-button color="primary" (click)="addIconColumn()">
        Add Icon Column
      </button>
    </div>
  </section>

  <hr class="editor-divider" />

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Styles</h2>
    </div>
    <div class="editor-section__content editor-section__content--spacious">
      <p class="section-intro">These settings affect the whole tile background.</p>
      <div class="background-settings">
        <mat-form-field appearance="fill">
          <mat-label>Background</mat-label>
          <input matInput formControlName="background" />
          <mat-hint>Defines the background shown behind all icon columns.</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </section>
</form>

<div class="footer" style="bottom: -20px">
  <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
</div>
